export default __webpack_public_path__ + "static/media/logo-160.38c26f8f.png";